import { cn } from '../utils/utils';

export default function LanguageChanger({
  isModelOpen = false,
  onChangeLanguage,
  currentLanguage,
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-2 tracking-widest',
        isModelOpen ? 'opacity-0 pointer-events-none' : 'opacity-100 pointer-events-auto',
      )}
    >
      <p
        className={cn(
          'text-white text-[10px]/[16px] lg:text-[14px]/[22px] select-none hover:text-white transition-colors duration-300',
          currentLanguage === 'en'
            ? 'text-[#F7C109] font-medium'
            : 'text-white/40 font-normal',
        )}
        role="button"
        onClick={() => {
          if (currentLanguage === 'pt') {
            onChangeLanguage('en');
          }
        }}
      >
        ENG
      </p>
      <div className="min-w-[1px] h-[16px] lg:h-[20px] bg-white/50" />
      <p
        className={cn(
          'text-white/40 font-normal text-[10px]/[16px] lg:text-[14px]/[22px] select-none hover:text-white transition-colors duration-300',
          currentLanguage === 'pt'
            ? 'text-[#F7C109] font-medium'
            : 'text-white/40 font-normal',
        )}
        role="button"
        onClick={() => {
          if (currentLanguage === 'en') {
            onChangeLanguage('pt');
          }
        }}
      >
        POR
      </p>
    </div>
  );
}
